export default __webpack_public_path__ + "static/media/camera-house-desktop-two.d15afe08.png";